/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IHealthCamp } from 'app/shared/model/health-camp.model';

export interface IHealthCampParticipant {
  id?: string;
  participantId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  attended?: boolean;
  role?: IClinicalDictionary | null;
  camp?: IHealthCamp | null;
}

export const defaultValue: Readonly<IHealthCampParticipant> = {
  active: false,
  attended: false,
};
